// src/app/shared/services/prospects.service.ts
import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders, HttpParams } from '@angular/common/http';
import { catchError, Observable, of, throwError } from 'rxjs';
import { Prospect, ProspectSummary } from 'src/app/domain/prospect.model';
import { CustomerProspectDTO } from 'src/app/domain/customer-prospect.dto';
import { ProspectCustomerDetailsDTO } from 'src/app/domain/prospect-customer-details.dto';

@Injectable({
  providedIn: 'root'
})
export class ProspectsService {
  // Mock data for development
  // private mockProspects: Prospect[] = [
  //   { id: 1, brand: "SBM Product", sector: "Public", customer: "HRDS", status: "New", oddPercent: "5%", sales: "Raed", title: "Muraslat Replacement", date: "1-Jan", serviceValue: "$240,000", remarks: "Muraslat" },
  //   { id: 2, brand: "Managed Service", sector: "Banking", customer: "Inma's Bank", status: "Closed as Won", oddPercent: "100%", sales: "Shalby", title: "Integration Onsite Engineer", date: "1-Jan", serviceValue: "$166,000", remarks: "" },
  //   { id: 3, brand: "Watheq", sector: "Banking", customer: "BAJ", status: "New", oddPercent: "50%", sales: "Shalby", title: "Screening Engine and Onsite Support Eng", date: "1-Jan", serviceValue: "$114,000", remarks: "Watheeq" },
  //   { id: 4, brand: "Integration", sector: "Banking", customer: "ANB", status: "New", oddPercent: "10%", sales: "Gamal", title: "IIB/APP Connect Upgrade", date: "8-Jan", serviceValue: "$900,000", remarks: "" },
  //   { id: 5, brand: "Watheq", sector: "Banking", customer: "SNB", status: "InProgress", oddPercent: "50%", sales: "Sharaf", title: "CR/B2B Account Statement Report", date: "9-Jan", serviceValue: "$3,733", remarks: "" },
  //   { id: 6, brand: "Watheq", sector: "Banking", customer: "JPM", status: "New", oddPercent: "80%", sales: "Ghiadaa", title: "2025 AMC", date: "10-Jan", serviceValue: "$175,770", remarks: "" }
  // ];


    PATH = "/appliances/api/v2/prospect"
    ACTIVITY_PATH = "/appliances/api/v2/prospectActivities"
    USER_PATH = "/appliances/api/v2/user"
    OPPORTUNITY_PATH = "/api/v1/opportunity"
    CUSTOMER_PATH = "/appliances/api/v2/customers"

  constructor(private httpClient: HttpClient) { }

  /**
   * Get sector info by customer ID.
   * @param customerId The customer ID.
   * @returns Observable with sector info { id: number, name: string }
   */
  getSectorByCustomerId(customerId: number): Observable<{ id: number, name: string }> {
    const token = localStorage.getItem('token');
    const headers = new HttpHeaders().set('Authorization', `Bearer ${token}`);
    return this.httpClient.get<{ id: number, name: string }>(
      `${this.CUSTOMER_PATH}/sector/${customerId}`,
      { headers }
    ).pipe(catchError(this.errorHandler));
  }

  // In a real application, these would make API calls
  getAllProspects(): Observable<Prospect[]> {
    const token = localStorage.getItem("token");
       const headers = new HttpHeaders().set('Authorization', `Bearer ${token}`);

       return this.httpClient.get<Prospect[]>(this.PATH + '/' ,{headers})
         .pipe(catchError(this.errorHandler));
  }

  getProspectById(id: number): Observable<any> {
    const token = localStorage.getItem("token");
    const headers = new HttpHeaders().set('Authorization', `Bearer ${token}`);

    return this.httpClient.get<any>(this.PATH + `/${id}` ,{headers})
      .pipe(catchError(this.errorHandler));
    return
  }

  addProspect(prospect: Prospect): Observable<any> {
    const token = localStorage.getItem("token");
    const headers = new HttpHeaders().set('Authorization', `Bearer ${token}`);

    return this.httpClient.post<any>(this.PATH + '/' , prospect ,{headers})
      .pipe(catchError(this.errorHandler));

  }  
  
  updateProspect(prospect: Prospect , id :number): Observable<Prospect> {
    const token = localStorage.getItem("token");
    const headers = new HttpHeaders().set('Authorization', `Bearer ${token}`);
    
    // Create a copy to ensure we don't modify the original object
    const requestData = { ...prospect, prospectId: id };
    
    // Log the request data with the ID for debugging
    console.log(`Sending PUT request to ${this.PATH}/${id} with prospectId=${requestData.prospectId}`);

    return this.httpClient.put<any>(this.PATH + `/${id}` , requestData ,{headers})
      .pipe(catchError(this.errorHandler));

  }

  deleteProspect(id: number): Observable<void> {
    const token = localStorage.getItem("token");
    const headers = new HttpHeaders().set('Authorization', `Bearer ${token}`);

    return this.httpClient.delete<any>(this.PATH + `/${id}` ,{headers})
      .pipe(catchError(this.errorHandler));
  }

  // updateProspectStatus(id: number, nextStatus: string, comment: string, attachment: File | null) {
  //     const token = localStorage.getItem("token");
  //     const headers = new HttpHeaders().set('Authorization', `Bearer ${token}`);
  //     const dto = {
  //       prospectId: id,
  //       status: nextStatus,
  //       comment: comment,
  //       attachment: attachment
  //     };

  //     console.log( "DTO", dto);

  //   return this.httpClient.post<any>(this.PATH + '/updateStatus', dto ,{headers})
  //        .pipe(catchError(this.errorHandler));

  // }


  updateProspectStatus(
    id: number,
    nextStatus: string,
    comment: string,
    attachment: File | null
) {
    const token = localStorage.getItem('token');
    const headers = new HttpHeaders().set('Authorization', `Bearer ${token}`);

    const formData = new FormData();
    formData.append('prospectId', id.toString());
    formData.append('status', nextStatus);
    formData.append('comment', comment);
    if (attachment) {
        formData.append('attachment', attachment);
        formData.append('attachmentName' , attachment.name);
        formData.append('attachmentType' , attachment.type);
    }

    return this.httpClient
        .post<any>(`${this.PATH}/updateStatus`, formData, { headers })
        .pipe(catchError(this.errorHandler));
}



// updateProspectStatus(
//   id: number,
//   nextStatus: string,
//   comment: string,
//   attachment: File | null
// ) {
//   const token = localStorage.getItem('token');
//   const headers = new HttpHeaders().set('Authorization', `Bearer ${token}`);

//   const formData = new FormData();
//   formData.append('prospectId', id.toString());
//   formData.append('status', nextStatus);
//   formData.append('comment', comment);

//   if (attachment) {
//       const reader = new FileReader();
//       reader.readAsDataURL(attachment); // Convert file to Base64
//       reader.onload = () => {
//           const base64String = (reader.result as string).split(',')[1]; // Remove Base64 prefix
//           formData.append('attachment', base64String);
//           formData.append('attachmentName', attachment.name);
//           formData.append('attachmentType', attachment.type);

//           // Send the request only after the file is converted
//           this.httpClient
//               .post<any>(`${this.PATH}/updateStatus`, formData, { headers })
//               .pipe(catchError(this.errorHandler))
//               .subscribe();
//       };
//   } else {
//       // If there's no attachment, send the request immediately
//       return this.httpClient
//           .post<any>(`${this.PATH}/updateStatus`, formData, { headers })
//           .pipe(catchError(this.errorHandler));
//   }
// }


// In your service (e.g., prospects.service.ts)

getProspectSummaryByCustomers(years?: number[]): Observable<ProspectSummary[]> {
  const token = localStorage.getItem('token');
  const headers = new HttpHeaders().set('Authorization', `Bearer ${token}`);

  let params = new HttpParams();
  if (years && years.length > 0) {
    // Send as comma-separated string: ?years=2024,2025,2026
    params = params.set('years', years.join(','));
  }

  return this.httpClient.get<ProspectSummary[]>(this.PATH + "/summary/customers", { headers, params })
    .pipe(catchError(this.errorHandler));
}

getProspectSummaryBySectors(years?: number[]): Observable<ProspectSummary[]> {
  const token = localStorage.getItem('token');
  const headers = new HttpHeaders().set('Authorization', `Bearer ${token}`);

  let params = new HttpParams();
  if (years && years.length > 0) {
    // Send as comma-separated string: ?years=2024,2025,2026
    params = params.set('years', years.join(','));
  }

  return this.httpClient.get<ProspectSummary[]>(this.PATH + "/summary/sectors", { headers, params })
    .pipe(catchError(this.errorHandler));
}

getProspectActivitySummary(): Observable<any[]> {
  const token = localStorage.getItem('token');
  const headers = new HttpHeaders().set('Authorization', `Bearer ${token}`);

  return this.httpClient.get<any[]>(this.PATH + "/prospectActivitySummary", { headers })
    .pipe(catchError(this.errorHandler));
}

generateReport(): Observable<Blob> {
  // Mock implementation
  // In a real app, this would call an API endpoint that returns a Blob
  return of(new Blob(['mock report data'], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }));
}



  getAllProspectSummaryByYearAndMonth(): Observable<any[]> {
    const token = localStorage.getItem('token');
    const headers = new HttpHeaders().set('Authorization', `Bearer ${token}`);

    return this.httpClient.get<any[]>(this.PATH + "/summary/app-prospect", { headers })
      .pipe(catchError(this.errorHandler));
  }



  getBrandProspectSummary(): Observable<any[]> {
    const token = localStorage.getItem('token');
    const headers = new HttpHeaders().set('Authorization', `Bearer ${token}`);

    return this.httpClient.get<any[]>(this.PATH + "/summary/brand-prospect", { headers })
      .pipe(catchError(this.errorHandler));
  }


  getCustomerProspectSummary(): Observable<any[]> {
    const token = localStorage.getItem('token');
    const headers = new HttpHeaders().set('Authorization', `Bearer ${token}`);

    return this.httpClient.get<any[]>(this.PATH + "/summary/customer-prospect", { headers })
      .pipe(catchError(this.errorHandler));
  }

  searchOpportunities(customerId: number, sectorId: number, year: number, statusList: number[]): Observable<any[]> {
    const token = localStorage.getItem('token');
    const headers = new HttpHeaders({ Authorization:  sessionStorage.getItem('basicauth')  });

    const requestBody = {
      customerId: customerId,
      sectorId: sectorId,
      year: year,
      statusList: statusList
    };

    return this.httpClient.post<any[]>(`${this.OPPORTUNITY_PATH}/search`, requestBody, { headers })
      .pipe(catchError(this.errorHandler));
  }

  getUserTags(userId: number): Observable<any> {
    const token = localStorage.getItem('token');
    const headers = new HttpHeaders().set('Authorization', `Bearer ${token}`);

    return this.httpClient.get<any>(`${this.USER_PATH}/get-tag-by-user-id/${userId}`, { headers })
      .pipe(catchError(this.errorHandler));
  }

  addActivity(activity : any): Observable<any> {
    const token = localStorage.getItem("token");
    const headers = new HttpHeaders().set('Authorization', `Bearer ${token}`);

    return this.httpClient.post<any>(this.ACTIVITY_PATH , activity ,{headers})
      .pipe(catchError(this.errorHandler));
  }  
  editProspectActivity(id: number, editData: any): Observable<any> {
    const token = localStorage.getItem('token');
    const headers = new HttpHeaders().set('Authorization', `Bearer ${token}`);

    return this.httpClient.put<any>(`${this.ACTIVITY_PATH}/${id}/edit`, editData, { headers })
      .pipe(catchError(this.errorHandler));
  }
  
  deleteProspectActivity(id: number): Observable<any> {
    const token = localStorage.getItem('token');
    const headers = new HttpHeaders().set('Authorization', `Bearer ${token}`);

    return this.httpClient.delete<any>(`${this.ACTIVITY_PATH}/${id}`, { headers })
      .pipe(catchError(this.errorHandler));
  }
  
  /**
   * Get prospect activities by their IDs
   * @param ids Array of prospect activity IDs to retrieve
   * @returns Observable with array of prospect activity details
   */
  getProspectActivitiesByIds(ids: number[]): Observable<any[]> {
    const token = localStorage.getItem('token');
    const headers = new HttpHeaders().set('Authorization', `Bearer ${token}`);

    return this.httpClient.post<any[]>(`${this.ACTIVITY_PATH}/byIds`, ids, { headers })
      .pipe(catchError(this.errorHandler));
  }
  
  /**
   * Get all prospects with customers that don't have opportunities
   * @returns Observable with array of CustomerProspectDTO objects containing prospect and customer info
   */
  getProspectsWithCustomersWithoutOpportunities(): Observable<CustomerProspectDTO[]> {
    const token = localStorage.getItem('token');
    const headers = new HttpHeaders().set('Authorization', `Bearer ${token}`);

    return this.httpClient.get<CustomerProspectDTO[]>(`${this.PATH}/customersWithoutOpportunities`, { headers })
      .pipe(catchError(this.errorHandler));
  }
  
  /**
   * Get all prospects without opportunities where the customer has other opportunities
   * @returns Observable with array of ProspectCustomerDetailsDTO objects containing prospect, customer, and technical leads info
   */
  getProspectsWithoutOpportunitiesWithCustomerHavingOpportunities(): Observable<ProspectCustomerDetailsDTO[]> {
    const token = localStorage.getItem('token');
    const headers = new HttpHeaders().set('Authorization', `Bearer ${token}`);

    return this.httpClient.get<ProspectCustomerDetailsDTO[]>(`${this.PATH}/prospectsWithoutOpportunities`, { headers })
      .pipe(catchError(this.errorHandler));
  }  errorHandler(error: HttpErrorResponse) {
      // Log the full error for debugging
      console.log('HTTP Error:', error);

      // Extract the error message based on the error structure
      let errorMessage: string;

      if (error.error instanceof ErrorEvent) {
        // Client-side error
        errorMessage = `Client Error: ${error.error.message}`;
      } else if (typeof error.error === 'string') {
        // Server returned error as string
        errorMessage = error.error;
      } else if (error.error && error.error.message) {
        // Server returned error with message property
        errorMessage = error.error.message;
      } else if (error.status === 404) {
        // Not found errors
        errorMessage = `Resource not found: ${error.url}`;
      } else if (error.status === 400) {
        // Bad request errors
        errorMessage = `Bad request: ${error.statusText}`;
      } else {
        // Default error message
        errorMessage = error.message || 'Server Error';
      }

      console.log('Processed error message:', errorMessage);

      return throwError(errorMessage);
  }  setOpportunityToProspect(prospectId: number, opportunityId: number): Observable<any> {
    const token = localStorage.getItem('token');
    const headers = new HttpHeaders()
      .set('Authorization', `Bearer ${token}`)
      .set('Content-Type', 'text/plain'); // Send as plain text

    // Log the ID values being sent to the API
    console.log(`ProspectsService: Linking opportunity ID ${opportunityId} to prospect ID ${prospectId}`);

    // Ensure both IDs are valid numbers
    const numericProspectId = Number(prospectId);
    const numericOpportunityId = Number(opportunityId);

    if (isNaN(numericProspectId) || numericProspectId <= 0) {
      console.error('Invalid prospect ID:', prospectId);
      return throwError('Invalid prospect ID');
    }

    if (isNaN(numericOpportunityId) || numericOpportunityId <= 0) {
      console.error('Invalid opportunity ID:', opportunityId);
      return throwError('Invalid opportunity ID');
    }

    // Send the opportunity ID as a raw number (will be converted to string)
    // The backend expects a raw Long value, not a JSON object
    return this.httpClient.post<any>(
      `${this.PATH}/${numericProspectId}/setOpportunity`,
      numericOpportunityId.toString(), // Convert to string for text/plain body
      { headers }
    ).pipe(catchError(this.errorHandler));
  }





}


